import React from "react";
import "aos/dist/aos.css";
import { Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import {useEffectOnce} from "../../../redux/hooks/useEffectOnce";
import {actionToGetBlogDataApiCall} from "../../../redux/action";
import BlogComponent from "./BlogComponent";
import BlogContent from "./BlogContent";
const BlogPage = () => {
    const dispatch = useDispatch();

    useEffectOnce(() => {
        dispatch(actionToGetBlogDataApiCall());
    });


    return (
        <Routes>
            <Route path="/" element={<BlogComponent />} />
            <Route path="/:slug" element={<BlogContent />} />
        </Routes>
    );
};

export default React.memo(BlogPage);
